export default {"src":"/_next/static/media/shopping-cart.12c59790.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};